<template>
  <div class="root">
      <div >
        <logo-button
          @click="$emit('onPrintWorkOrder', $event)"
          :getPdfContent="getPdfContentWo"
        >
          {{L10n('print-work-order')}}
        </logo-button>
      </div>
      <div >
        <logo-button
          @click="$emit('onPrintPO', $event)"
          :getPdfContent="getPdfContentPo"
        >
          {{L10n('print-po')}}
        </logo-button>
      </div>
      <div >
        <logo-button
          @click="$emit('onPrintProformaSupplier', $event)"
          :getPdfContent="getPdfContentProformaSupplier"
        >
          {{L10n('print-proforma-ship-supplier')}}
        </logo-button>
      </div>
      <div >
        <logo-button
          @click="$emit('onSentPO', $event)"
          :getPdfContent="getPdfContentPo"
        >
          {{L10n('send-po')}}
        </logo-button>
      </div>
      <div >
        <logo-button
          @click="$emit('onSentWO', $event)"
          :getPdfContent="getPdfContentWo"
        >
          {{L10n('send-wo')}}
        </logo-button>
      </div>
      <div >
        <el-button
          disabled
          size="small"
          type="primary"
          plain
        >
          {{L10n('print-proforma-ship-mro')}}
        </el-button>
      </div>
      <div >
        <el-button
          @click="$emit('onAddToSupportPoFollowUp')"
          size="small"
          type="primary"
          plain
        >
          {{L10n('add-to-support-po-follow-up')}}
        </el-button>
      </div>
      <div >
        <el-button
          @click="command('update-stock-location-and-status')"
          size="small"
          type="primary"
          plain
        >
          {{L10n('update-stock-location-and-status')}}
        </el-button>
      </div>
      <div >
        <el-button
          @click="command('add-new-pn-to-stock')"
          size="small"
          type="primary"
          plain
        >
          {{L10n('add-new-pn-to-stock-use-only-for-purchase-not-repair')}}
        </el-button>
      </div>
    </div>
</template>

<script>
import { ServicePdf } from '@/services/pdf-generators'

export default {
  name: 'ButtonsSection',
  components: {
    'logo-button': () => import(/* webpackChunkName: 'UI' */ '@/components/Shared/LogoButton')
  },
  props: {
    id: { type: String },
    salesOrderID: { type: String }
  },
  methods: {
    command (command) {
      this.$emit('command', command)
    },
    getPdfContentWo () {
      const translate = this.L10n
      return ServicePdf.generateWoContent({ id: this.id, salesOrderID: this.salesOrderID, translate })
    },
    getPdfContentPo () {
      const translate = this.L10n
      return ServicePdf.generatePoContent({ id: this.id, salesOrderID: this.salesOrderID, translate })
    },
    getPdfContentProformaSupplier () {
      const translate = this.L10n
      return ServicePdf.generateProformaShipSupplierContent({ id: this.id, salesOrderID: this.salesOrderID, translate })
    }
  }
}
</script>

<style scoped>
  .root{
    display: flex;
    flex-wrap: wrap;
    gap: 0.8rem
  }
</style>
